import { render, staticRenderFns } from "./Ubicacion.vue?vue&type=template&id=efa6d1b6"
import script from "./Ubicacion.vue?vue&type=script&lang=js"
export * from "./Ubicacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports